import { CLIENT_PAYMENT_WALLETS } from "./clientPaymentWallets";

export const CLIENT_PAYMENT_OPTIONS = [
  {
    key: "usdt_trc20",
    title: "Tether TRC-20",
    subtitle: "USDT Wallet",
    symbol: "USDT",
    network: "TRON",
    wallet: CLIENT_PAYMENT_WALLETS.usdt_tron,
    iconKey: "usdt",
    routeId: "69165ffba67463d377262da9",
  },
  {
    key: "usdt_arbitrum",
    title: "Tether ARBITRUM",
    subtitle: "USDT Wallet",
    symbol: "USDT",
    network: "Arbitrum",
    wallet: CLIENT_PAYMENT_WALLETS.usdt_arbitrum,
    iconKey: "usdt",
    routeId: "6977d9934b5fc93aa28280a6",
  },
  {
    key: "usdt_avax",
    title: "Tether AVALANCHE",
    subtitle: "USDT Wallet",
    symbol: "USDT",
    network: "Avalanche",
    wallet: CLIENT_PAYMENT_WALLETS.usdt_avax,
    iconKey: "usdt",
    routeId: "6977d9a64684b619a006b636",
  },
  {
    key: "usdt_bsc",
    title: "Tether BEP-20",
    subtitle: "USDT Wallet",
    symbol: "USDT",
    network: "BSC",
    wallet: CLIENT_PAYMENT_WALLETS.usdt_bsc,
    iconKey: "usdt",
    routeId: "6977d9c6eb134cd607d2f89c",
  },
  {
    key: "usdt_eth",
    title: "Tether ERC-20",
    subtitle: "USDT Wallet",
    symbol: "USDT",
    network: "Ethereum",
    wallet: CLIENT_PAYMENT_WALLETS.usdt_eth,
    iconKey: "usdt",
    routeId: "6977d9d3bcf2fd90048400a7",
  },
  {
    key: "usdt_polygon",
    title: "Tether POLYGON",
    subtitle: "USDT Wallet",
    symbol: "USDT",
    network: "Polygon",
    wallet: CLIENT_PAYMENT_WALLETS.usdt_polygon,
    iconKey: "usdt",
    routeId: "6977d9e04b5fc93aa2828551",
  },
  {
    key: "usdt_sol",
    title: "Tether SOL",
    subtitle: "USDT Wallet",
    symbol: "USDT",
    network: "Solana",
    wallet: CLIENT_PAYMENT_WALLETS.usdt_sol,
    iconKey: "usdt",
    routeId: "6977d9f2eb134cd607d2f8ec",
  },
  {
    key: "usdt_ton",
    title: "Tether TON",
    subtitle: "USDT Wallet",
    symbol: "USDT",
    network: "TON",
    wallet: CLIENT_PAYMENT_WALLETS.usdt_ton,
    iconKey: "usdt",
    routeId: "6977da04eb134cd607d2f913",
  },
  {
    key: "usdc_arbitrum",
    title: "USDC Arbitrum",
    subtitle: "USDT Wallet",
    symbol: "USDC",
    network: "Arbitrum",
    wallet: CLIENT_PAYMENT_WALLETS.usdc_arbitrum,
    iconKey: "usdc",
    routeId: "6977dfeb4684b619a0070099",
  },
  {
    key: "usdc_bsc",
    title: "USDC BEP-20",
    subtitle: "USDT Wallet",
    symbol: "USDC",
    network: "BSC",
    wallet: CLIENT_PAYMENT_WALLETS.usdc_bsc,
    iconKey: "usdc",
    routeId: "6977e007bcf2fd9004844fb8",
  },
  {
    key: "usdc_eth",
    title: "USDC ERC-20",
    subtitle: "USDT Wallet",
    symbol: "USDC",
    network: "Ethereum",
    wallet: CLIENT_PAYMENT_WALLETS.usdc_eth,
    iconKey: "usdc",
    routeId: "6977e01d4b5fc93aa282e407",
  },
  {
    key: "avax",
    title: "Avalanche",
    subtitle: "USDT Wallet",
    symbol: "AVAX",
    network: "Avalanche",
    wallet: CLIENT_PAYMENT_WALLETS.avax,
    iconKey: "avax",
    routeId: "6977da634b5fc93aa282862a",
  },
  {
    key: "bch",
    title: "Bitcoin Cash",
    subtitle: "USDT Wallet",
    symbol: "BCH",
    network: "Bitcoin Cash",
    wallet: CLIENT_PAYMENT_WALLETS.bch,
    iconKey: "bch",
    routeId: "6977db2b4684b619a006ca57",
  },
  {
    key: "bnb",
    title: "BinanceCoin BEP20",
    subtitle: "USDT Wallet",
    symbol: "BNB",
    network: "BSC",
    wallet: CLIENT_PAYMENT_WALLETS.bnb,
    iconKey: "bnb",
    routeId: "6977db4eeb134cd607d31511",
  },
  {
    key: "btc",
    title: "Bitcoin",
    subtitle: "USDT Wallet",
    symbol: "BTC",
    network: "Bitcoin",
    wallet: CLIENT_PAYMENT_WALLETS.btc,
    iconKey: "btc",
    routeId: "6977db82eb134cd607d31560",
  },
  {
    key: "dash",
    title: "Dash",
    subtitle: "USDT Wallet",
    symbol: "DASH",
    network: "Dash",
    wallet: CLIENT_PAYMENT_WALLETS.dash,
    iconKey: "dash",
    routeId: "6977dc1a4684b619a006cbc0",
  },
  {
    key: "doge",
    title: "Dogecoin",
    subtitle: "USDT Wallet",
    symbol: "DOGE",
    network: "Dogecoin",
    wallet: CLIENT_PAYMENT_WALLETS.doge,
    iconKey: "doge",
    routeId: "6977dc2e4684b619a006cbe3",
  },
  {
    key: "ltc",
    title: "Litecoin",
    subtitle: "USDT Wallet",
    symbol: "LTC",
    network: "Litecoin",
    wallet: CLIENT_PAYMENT_WALLETS.ltc,
    iconKey: "ltc",
    routeId: "6977df084b5fc93aa282d9c1",
  },
  {
    key: "sol",
    title: "Solana",
    subtitle: "USDT Wallet",
    symbol: "SOL",
    network: "Solana",
    wallet: CLIENT_PAYMENT_WALLETS.sol,
    iconKey: "sol",
    routeId: "6977df3aeb134cd607d345f6",
  },
  {
    key: "ton",
    title: "Toncoin",
    subtitle: "USDT Wallet",
    symbol: "TON",
    network: "TON",
    wallet: CLIENT_PAYMENT_WALLETS.ton,
    iconKey: "ton",
    routeId: "6977df574684b619a006ffa5",
  },
  {
    key: "trx",
    title: "TRON",
    subtitle: "USDT Wallet",
    symbol: "TRX",
    network: "TRON",
    wallet: CLIENT_PAYMENT_WALLETS.trx,
    iconKey: "trx",
    routeId: "6977df764b5fc93aa282e2eb",
  },
  {
    key: "xmr",
    title: "Monero",
    subtitle: "USDT Wallet",
    symbol: "XMR",
    network: "Monero",
    wallet: CLIENT_PAYMENT_WALLETS.xmr,
    iconKey: "xmr",
    routeId: "6977dfc7bcf2fd9004844f51",
  },
  {
    key: "dai_eth",
    title: "DAI",
    subtitle: "USDT Wallet",
    symbol: "DAI",
    network: "Ethereum",
    wallet: CLIENT_PAYMENT_WALLETS.dai_eth,
    iconKey: "dai",
    routeId: "69792f12bcf2fd900485bcc0",
  },
  {
    key: "eth_eth",
    title: "Ethereum erc-20",
    subtitle: "USDT Wallet",
    symbol: "ETH",
    network: "Ethereum",
    wallet: CLIENT_PAYMENT_WALLETS.eth_eth,
    iconKey: "eth",
    routeId: "69792f4abcf2fd900485bd24",
  },
  {
    key: "matic_eth",
    title: "Polygon",
    subtitle: "USDT Wallet",
    symbol: "MATIC",
    network: "Polygon",
    wallet: CLIENT_PAYMENT_WALLETS.matic_eth,
    iconKey: "matic",
    routeId: "69792f844684b619a00840ec",
  },
  {
    key: "shib_eth",
    title: "Shiba ERC20",
    subtitle: "USDT Wallet",
    symbol: "SHIB",
    network: "Ethereum",
    wallet: CLIENT_PAYMENT_WALLETS.shib_eth,
    iconKey: "shib",
    routeId: "697930384684b619a0084208",
  },
  {
    key: "eth_bsc",
    title: "Ethereum bep-20",
    subtitle: "USDT Wallet",
    symbol: "ETH",
    network: "BSC",
    wallet: CLIENT_PAYMENT_WALLETS.eth_bsc,
    iconKey: "eth",
    routeId: "697931baeb134cd607d47790",
  },
  {
    key: "eth_arbitrum",
    title: "Ethereum arbitrum",
    subtitle: "USDT Wallet",
    symbol: "ETH",
    network: "Arbitrum",
    wallet: CLIENT_PAYMENT_WALLETS.eth_arbitrum,
    iconKey: "eth",
    routeId: "697931dceb134cd607d47bdf",
  },
];
